<template>
    <common-page>
        <div class="card" style="min-width: 100%">
            <mini-table ref="adjustTable"
                        class="m-1"
                        :items="scheduledResult.planDetailTree"
                        read-only
                        entity-name="sithMomMainProjectPlanDetail"
                        need-model-fields
                        :fields="tableFields"
                        enable-table-tree
                        tree-node-label-name="activityId"
                        tree-id-name="id"
                        tree-parent-id-name="parentId"
                        without-level break-children
                        disable-first-index-column
                        :default-expend-depth="3"
                        addition-columns="name"
                        custom-columns="keyInfo,process,predecessor"
                        filterable
                        :filter-switch-in-header="viewMode">
                <template #leftHeader>
                    <template v-if="!viewMode">
                        <mini-button variant="outline-success" loading-type="grow"
                                     :loading="saveLoading"
                                     @btnClick="$refs.save.showModal()">
                            <i class="fa-solid fa-floppy-disk"></i>
                            Save
                        </mini-button>
                        <mini-button class="ml-1" variant="outline-info"
                                     :loading="releaseLoading"
                                     confirm-text="确认释放吗？请确保在操作前您已经保存了排产结果！"
                                     @btnClick="release">
                            Release
                        </mini-button>
                    </template>
                </template>
                <template #custom(process)="{row}">
                    <b-progress style="width: 80px" variant="info"
                                :value="row.process" :max="100" show-value></b-progress>
                </template>
                <template #custom(keyInfo)="{row}">
                    <div class="d-flex flex-column">
                        <div>
                            <b-badge v-if="row.isCriticalPath" variant="danger">关键路径</b-badge>
                            <b-badge
                                v-if="row.lastBeginTime !== row.mainBeginTime || row.lastEndTime !== row.mainEndTime"
                                class="ml-1" variant="warning">上版变动
                            </b-badge>
                        </div>
                    </div>
                </template>
                <template #addition(name)="{row}">
                    <div v-if="!viewMode" class="action-cover">
                        <b-button variant="light" class="ml-1" @click="openAdjustModal(row)">
                            <i class="fa-solid fa-pen-ruler"></i>
                        </b-button>
                    </div>
                </template>
                <template #custom(predecessor)="{row,val}">
                    <template v-if="translatedPredecessor[row.id]">
                        {{ translatedPredecessor[row.id] }}
                    </template>
                    <template v-else>
                        {{ val }}
                    </template>
                </template>

                <template #headAddition(resource)>
                    <mini-button variant="light" class="ml-1"
                                 style="padding: 0 0.25rem !important;"
                                 :loading="resourceEditLoading"
                                 @btnClick="editOrSaveResource">
                        <i v-if="resourceEdit" class="fa-solid fa-floppy-disk"></i>
                        <i v-else class="fa-solid fa-pen-to-square"></i>
                    </mini-button>
                </template>
            </mini-table>
        </div>
        <template #outer>
            <re-b-modal ref="save" header="保存排产结果"
                        @ok="saveScheduledResult">
                <diverse-input :value.sync="adjustReason" :config="saveInputConfig"></diverse-input>
            </re-b-modal>

            <re-b-modal ref="adjust" header="调整计划"
                        no-auto-hide disableScrollable
                        @ok="adjustPlan">
                <diverse-input-group ref="adjustInputGroup"
                                     :configs="adjustInputConfig"
                                     @change="whenAdjustValueChange"></diverse-input-group>
                <diverse-input-group v-if="needRecord" ref="recordInputGroup"
                                     :configs="adjustRecordConfig"></diverse-input-group>
                <b-form-checkbox v-model="needRecord" size="lg" switch></b-form-checkbox>
            </re-b-modal>
        </template>
    </common-page>
</template>

<script>
import {defineComponent} from 'vue'
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput.vue";
import commonViewsUtil from "@/utils/commonViewsUtil";
import DiverseInputGroup from "@/components/workflow/stuffs/DiverseInputGroup.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default defineComponent({
    name: "MainProjectPlanAdjust",
    mixins: [emCommonUtilMixin],
    components: {MiniButton, DiverseInputGroup, DiverseInput, ReBModal, MiniTable, CommonPage},
    data() {
        return {
            viewMode: false,
            scheduledResult: {},

            adjustReason: '',
            saveInputConfig: {label: "调整原因", type: "textarea"},
            saveLoading: false,

            needRecord: false,
            adjustRecordConfig: [
                {
                    label: '调整原因类别', name: 'reasonType', type: 'select',
                    options: [
                        {value: 1, text: '项目'},
                        {value: 2, text: '工程'},
                        {value: 3, text: '采购'},
                        {value: 4, text: '生产'},
                        {value: 5, text: '负荷'},
                        {value: 6, text: '客户'},
                        {value: 7, text: '转子'},
                        {value: 8, text: '轴承'},
                        {value: 9, text: '其他'},
                    ]
                },
                {label: '调整原因描述', name: 'reason', type: 'textarea'},
                {
                    label: '是否影响交期', name: 'delivery', type: 'select',
                    options: [
                        {value: true, text: '是'},
                        {value: false, text: '否'},
                    ]
                },
                {label: '影响交期天数', name: 'deliveryDays', type: 'input', format: 'number'},
                {label: '备注', name: 'remark', type: 'textarea'},
            ],
            adjustingRow: null,
            adjustLoading: false,

            currentMissionMode: 1,

            releaseLoading: false,
            resourceSet: [],

            translatedPredecessor: {},

            resourceEdit: false,
            resourceEditLoading: false,
        }
    },
    computed: {
        adjustInputConfig() {
            let tempList = [
                {label: "缓冲时间", name: "bufferTime", type: "input", format: 'number'},
                {label: "周期", name: "duration", type: "input", format: 'number'},
                {label: "前置依赖", name: "predecessor", type: "textarea"},
                {label: "Resource", name: "resource", type: "input"},
                {
                    label: "任务模式",
                    name: "missionMode",
                    type: "select",
                    options: [{text: '自动计划', value: 1}, {text: '手动计划', value: 2}]
                }
            ];
            if (this.currentAdjustIsManual) {
                this.pushAll([
                    {label: "MPS开始", name: "mainBeginTime", type: "datetime", resetAble: true},
                    {label: "MPS结束", name: "mainEndTime", type: "datetime", resetAble: true},
                ], tempList);
            }
            return tempList;
        },
        currentAdjustIsManual() {
            return this.currentMissionMode === 2;
        },
        tableFields() {
            let formatter = val => {
                return val ? val.substring(0, 10) : val;
            }
            return [
                {key: 'resource', isInput: this.resourceEdit},
                {key: 'ppdOmForecastStartTime', valueFormatter: formatter},
                {key: 'ppdOmForecastEndTime', valueFormatter: formatter},
                {key: 'mainBeginTime', valueFormatter: formatter},
                {key: 'mainEndTime', valueFormatter: formatter},
            ]
        },
    },
    mounted() {
        this.scheduledResult = this.$route.params.scheduledResult ? this.$route.params.scheduledResult : {}
        this.translatePredecessor();
        this.viewMode = this.$route.params.readOnly;
        if (!this.viewMode) {
            this.queryResources();
        }
    },
    methods: {
        saveScheduledResult() {
            this.saveLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlan/saveScheduledResult?adjustReason=" + this.adjustReason,
                data: null
            }).then(() => {
                // this.$router.push({name: 'sithMomMainProjectPlanList', params: {needRefresh: "true"}})
                commonViewsUtil.showSuccess(this, "保存成功")
            }).finally(() => this.saveLoading = false);
        },
        openAdjustModal(row) {
            this.adjustingRow = row;
            this.currentMissionMode = row.missionMode;
            this.$refs.adjust.showModal();
            this.$nextTick(() => {
                this.$refs.adjustInputGroup.initInputData({
                    bufferTime: row.bufferTime,
                    duration: row.duration,
                    predecessor: row.predecessor,
                    resource: row.resource,
                    missionMode: row.missionMode,
                    mainBeginTime: row.mainBeginTime,
                    mainEndTime: row.mainEndTime,
                })
            })
        },
        adjustPlan() {
            this.adjustLoading = true;
            let inputData = this.$refs.adjustInputGroup.getInputData();
            inputData.projectDetailId = this.adjustingRow.id;
            if (!this.hasCode(inputData.mainBeginTime) && !this.hasCode(inputData.mainEndTime)) {
                this.$message.warning("请填入一个时间或改用自动计划");
                return;
            }
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlanDetail/adjust",
                data: inputData
            }).then(response => {
                this.scheduledResult = response.data;
                this.translatePredecessor();
                this.createAdjustRecord();
            }).finally(() => this.adjustLoading = false);
        },
        createAdjustRecord() {
            if (this.needRecord) {
                let inputData = this.$refs.recordInputGroup.getInputData();
                inputData.mainProjectPlanDetailId = this.adjustingRow.id;
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlanScheduledRecord/createNoParentRecord",
                    data: inputData
                }).then(() => {
                    this.adjustFinish();
                });
            } else {
                this.adjustFinish();
            }
        },
        adjustFinish: function () {
            commonViewsUtil.showSuccess(this, "调整完成")
            this.$refs.adjust.hide();
        },

        release() {
            let planMap = this.scheduledResult.planMap;
            if (planMap) {
                let planIds = Object.keys(planMap);
                console.log(planMap, planIds);
                if (planIds.length > 0) {
                    this.releaseLoading = true;
                    this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlan/release?planIds=" + planIds.join(",")
                    }).then(() => {
                        this.$message.success("释放成功");
                    }).finally(() => this.releaseLoading = false);
                }
            }
        },

        queryResources() {
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectTemplate/query/resources"
            }).then(response => {
                if (response) {
                    this.resourceSet = response;
                }
            });
        },

        translatePredecessor() {
            let planDetailMap = this.scheduledResult.planDetailMap;
            if (planDetailMap) {
                for (let id in planDetailMap) {
                    let predecessor = planDetailMap[id].predecessor;
                    if (predecessor) {
                        predecessor = predecessor.replace("，", ",");
                        let tempList = [];
                        let p_splits = predecessor.split(",");
                        for (let p_str of p_splits) {
                            let indexOfSpace = p_str.indexOf(' ');
                            let p_id = p_str.substring(0, indexOfSpace);
                            if (planDetailMap.hasOwnProperty(p_id)) {
                                tempList.push(planDetailMap[p_id].activityId + p_str.substring(indexOfSpace));
                            } else {
                                tempList.push(p_str);
                            }
                        }
                        this.translatedPredecessor[id] = tempList.join(",");
                    }
                }
            }
        },

        whenAdjustValueChange({key, value}) {
            console.log(key, value);
            if (key === 'missionMode') {
                this.currentMissionMode = value;
            }
        },

        editOrSaveResource() {
            if (this.resourceEditLoading) {
                return;
            }
            if (this.resourceEdit) {
                this.resourceEditLoading = true;
                let editData = this.$refs.adjustTable.finalColumnEditData();
                console.log(editData, 'ed');
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/common/edit/SithMomMainProjectPlanDetail",
                    data: {
                        editRows: editData
                    }
                }).then(() => {
                    this.$message.success('Save success');
                    let map = new Map();
                    editData.forEach(o => {
                        map.set(o.id, o.resource);
                    })
                    let tree = this.scheduledResult.planDetailTree;
                    this.traceTree(tree, map);
                    this.resourceEdit = false;
                }).finally(() => {
                    this.resourceEditLoading = false;
                });
            } else {
                this.resourceEdit = true;
            }
        },

        traceTree(tree, map) {
            for (let e of tree) {
                e.resource = map.get(e.id);
                if (e.children) {
                    this.traceTree(e.children, map);
                }
            }
        },
    }
})
</script>

<style scoped>
.action-cover {
    opacity: 0;
    width: min-content;
    margin-left: auto;
}

.action-cover:hover {
    opacity: 1;
}
</style>
